var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChartBarHorizontal = function SvgIconChartBarHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.75 3.75a1 1 0 0 0-2 0v16.5a1 1 0 1 0 2 0v-.5h8a1 1 0 0 0 1-1v-3.5h6.5a1 1 0 0 0 1-1v-4.5a1 1 0 0 0-1-1h-3.5v-3.5a1 1 0 0 0-1-1h-11zm14.5 9.5v-2.5H4.75v2.5zm-7.5 2v2.5h-7v-2.5zm-7-6.5h10v-2.5h-10z",
    clipRule: "evenodd"
  })));
};
export default SvgIconChartBarHorizontal;